import { TradingChip, TradingSpinner } from '@trading-ui/core';
import { BinIcon, PencilIcon } from '@trading-ui/icons';

import i18n from '@/i18n/config';

import type { Plant } from '@/interfaces';

import { TableUtils } from '../utils/table.utils';

type Params = {
  setSelectedCups: (cups: Plant) => void;
  handleDeletePlant: (id: number) => void;
  deletingId: number | null;
};

export const getCompanyCupsColumns = ({ setSelectedCups, handleDeletePlant, deletingId }: Params) => [
  {
    Header: i18n.t('settings.companyDetailsTab.companyCups.columns.cups'),
    accessor: 'identifier',
    width: 60,
    cellStyle: () => ({ backgroundColor: 'rgba(4, 120, 178, 0.2)', color: '#0478B2' }),
  },
  {
    Header: i18n.t('settings.companyDetailsTab.companyCups.columns.alias'),
    accessor: 'alias',
    width: 60,
  },
  {
    Header: i18n.t('settings.companyDetailsTab.companyCups.columns.users'),
    accessor: 'users',
    Cell: ({ row }: { row: { original: Plant } }) => (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
        {row.original.users.map((user) => (
          <TradingChip key={user.id} label={user.name} />
        ))}
      </div>
    ),
  },
  {
    Header: i18n.t('settings.companyDetailsTab.companyCups.columns.status'),
    accessor: 'status.code',
    width: 20,
    Cell: ({ value }: { value: string }) => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(),
    cellStyle: ({ row }: { row: { original: Plant } }) => ({
      color: TableUtils.getStatusCellColor(row.original.status.code),
    }),
  },
  {
    Header: '',
    accessor: 'edit',
    width: 20,
    cellStyle: () => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      cursor: 'pointer',
      backgroundColor: 'rgba(4, 120, 178, 0.2)',
      color: '#0478B2',
    }),
    Cell: ({ row }: { row: { original: Plant } }) => (
      <PencilIcon size={24} className="icon-hover" onClick={() => setSelectedCups(row.original)} />
    ),
  },
  {
    Header: '',
    accessor: 'delete',
    width: 20,
    cellStyle: () => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      cursor: 'pointer',
      backgroundColor: 'rgba(4, 120, 178, 0.2)',
      color: '#0478B2',
    }),
    Cell: ({ row }: { row: { original: Plant } }) =>
      deletingId === row.original.id ? (
        <TradingSpinner size={24} color="secondary" />
      ) : (
        <BinIcon size={24} className="icon-hover" onClick={() => handleDeletePlant(row.original.id)} />
      ),
  },
];
